var _circle, _circle2, _path, _circle3, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.57317,
    stroke: "#323942",
    strokeWidth: 0.853659
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00267,
    cy: 7.99974,
    r: 4.13158,
    stroke: "#323942"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.08203 0.129883C10.8543 0.0848494 13.7919 1.88112 15.2881 4.49023L8.00391 8.53711V0.131836C8.02979 0.131602 8.05609 0.129883 8.08203 0.129883Z",
    fill: "url(#paint0_linear_3116_5770)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00144,
    cy: 8.00046,
    r: 1.26316,
    fill: "#323942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.99958L15.2928 3.78906",
    stroke: "#323942",
    strokeWidth: 0.853659,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3116_5770",
    x1: 20.5087,
    y1: 5.7234,
    x2: 9.02472,
    y2: 3.1434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.553419,
    stopColor: "#323942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323942",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.5d1a77277aa0acd15c27314394a9b180.svg";
export { ForwardRef as ReactComponent };